import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * @deprecated
 */
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}
